var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWhatsapp = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "whatsapp_1_",
    "data-name": "whatsapp (1)",
    width: 22.976,
    height: 22.976,
    viewBox: "0 0 22.976 22.976",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M17.015,13.967l-.009.072c-2.105-1.049-2.325-1.189-2.6-.781-.189.282-.738.923-.9,1.112s-.334.2-.618.072a7.77,7.77,0,0,1-2.3-1.422A8.685,8.685,0,0,1,9,11.039c-.28-.484.306-.553.841-1.564a.526.526,0,0,0-.024-.5c-.072-.144-.643-1.551-.883-2.112s-.466-.488-.643-.488a1.425,1.425,0,0,0-1.31.329c-1.545,1.7-1.155,3.45.167,5.313,2.6,3.4,3.982,4.026,6.514,4.9a3.961,3.961,0,0,0,1.8.116,2.946,2.946,0,0,0,1.93-1.365A2.37,2.37,0,0,0,17.56,14.3c-.071-.129-.258-.2-.546-.33Z",
    transform: "translate(-0.255 -0.271)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M19.644,3.3C12.283-3.814.1,1.347.1,11.385a11.331,11.331,0,0,0,1.527,5.691L0,22.975l6.065-1.581a11.46,11.46,0,0,0,16.911-10A11.291,11.291,0,0,0,19.63,3.339Zm1.419,8.058A9.531,9.531,0,0,1,6.692,19.5l-.345-.2-3.59.933.962-3.489-.229-.359A9.495,9.495,0,0,1,18.278,4.668a9.37,9.37,0,0,1,2.785,6.692Z",
    transform: "translate(0 0)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhatsapp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whatsapp.e355aabc.svg";
export { ForwardRef as ReactComponent };